define('modules/costants-prod/module',[], function() {
    "use strict";
    var MODULE_NAME = "Constants";
    angular.module(MODULE_NAME, [])
        .constant("PATH", {
            APPROOTPATH: "",
            ENTRYPOINT: window.location.host + "/api/studioonline",
            DNSENTRYPOINT: window.location.host + "/api/dns",
            RIFERIMENTISTUDIOENTRYPOINT: window.location.host + "/api"
        })
        .constant("ANALYTICS", {
            ANALYTICSUACODE: "UA-40772646-1"
        });


    return MODULE_NAME;
});
